var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"seen-on",attrs:{"id":"seen-on"}},[_c('div',{staticClass:"grid grid--container"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }